<dialog 
  id="dialog-host"
  [class.visible]="dialogVisible" 
  [class.switching-away]="switchingDialog" 
  [class.switching-back]="switchingDialogBack"
  [class.shake]="dialogShaken"
  [class.animation-forward]="dialogAnimation == 'forward'"
  [class.animation-fly]="dialogAnimation == 'fly'"
  [class.animation-instant]="dialogAnimation == 'instant'"
  >
  <a href="javascript:;" (click)="closeDialog()" class="dialog-close" aria-label="Close">
    <i class="fa fa-times" aria-hidden="true"></i>  
  </a> 
  <div #dialogAnchor></div>    
</dialog>

<div id="dialog-background" (click)="hideDialog()" [class.active]="dialogVisible">
</div> 
<header *ngIf="!noLayout">
  <tyt-nav #nav></tyt-nav>
  <div class="alert-spacer" *ngFor="let alert of alerts"></div>
</header>
<main *ngIf="networkError" [class.chrome-flex]="noLayout || isChrome">
  <section class="server-down">
    <ng-container *ngIf="networkErrorType === 'offline'">
      <h1>No Internet connection</h1>
      <p>Looks like this content has not yet been downloaded to your device, 
        but there is a problem connecting to the Internet to download it. 
      Make sure your connection is working and try again. </p>
      <p>If your Internet connection is working properly, there may be a problem with our servers. If so, please try again later.</p>
      
      <div class="actions">
        <a class="btn btn-primary" href="javascript:;" onclick="window.location.reload()">Try Again</a>
      </div>
    </ng-container>
    <ng-container *ngIf="networkErrorType === 'serverDown'">
        <section class="server-down">
          <h1>Uh oh, we're having some trouble</h1>
          <p>Looks like a problem with our backend servers and this content hasn't been synced to your device yet. 
            Please try again later. If the problem persists, please contact 
            <a href="mailto:support@tytnetwork.com">support@tytnetwork.com</a>.</p>
          
          <div class="actions">
              <a class="btn btn-primary" href="javascript:;" onclick="window.location.reload()">Try Again</a>
              <a class="btn btn-primary" href="mailto:support@tytnetwork.com">Contact Support</a>
          </div>

          <br/>
          <br/>

          <h1>Should I check my Internet connection?</h1>
          It looks like your Internet connection is working properly, but it is possible that there is a problem 
          on your network that is specifically affecting TYT.com. Sometimes corporate networks, firewalls, or 
          browser extensions can interfere. 
          
          <p>If you suspect the issue may be on your end, here are some troubleshooting steps to try:</p> 
          <ul>
            <li>To rule out your network as the problem, try visiting TYT.com from a different Internet 
              connection if you can</li>
            <li>To determine if there's a compatibility problem with your browser, try using a different 
              browser if you can.
            </li>
            <li>To rule out a browser extension as the cause, try visiting TYT.com from an 
              Incognito, Private Browsing or InPrivate browsing session. Browsers typically 
              disable all extensions when you use a private browsing session. If TYT.com works 
              properly in the private browsing session, then a browser extension is likely to blame.
              Try turning them all off and enabling them one by one until TYT.com stops working to 
              determine which browser extension is causing the problem.
            </li> 
          </ul>

          <h1>Should I clear my cache and cookies?</h1>

          <p>There are very few situations where clearing your cache and cookies would solve an issue like this,
            and the pain of logging back in to all of your services means you should probably only try it as a last 
            resort. Furthermore, if the site isn't working within a private browsing session, it's very unlikely 
            that clearing your cache and cookies will help. That being said, if you have exhausted other troubleshooting 
            steps, it may be worth a shot.
          </p>
        </section>
    </ng-container>
    <ng-container *ngIf="networkErrorType === 'networkError'">
        <h1>Network Error</h1>
        <p>Looks like we're having trouble reaching TYT. 
        Make sure your connection is working and try again. </p>
        <p>If your Internet connection is working properly, 
          there may be a problem with our servers. If so, please try again later.</p>
        
        <div class="actions">
          <a class="btn btn-primary" href="javascript:;" onclick="window.location.reload()">Try Again</a>
        </div>
      
    </ng-container>
  </section>
</main>

<main [class.hidden]="networkError" [class.chrome-flex]="noLayout || isChrome">
  <router-outlet></router-outlet>
</main>

<footer id="main-footer" *ngIf="!noLayout">
  <tyt-staging-note only="staging" [shown]="true">
    This is the TYT staging installation. It is a separate installation which does not have the latest 
    content and data that is available from the production website.
  </tyt-staging-note>

  <app-carousel class="awards-carousel awards-carousel-desktop" *ngIf="!isServer">
    <app-carousel-item *ngFor="let awardPair of awardPairs">
      <div class="award-container" *ngFor="let award of awardPair">
        <responsive-picture
          [src]="award.logo"
          ></responsive-picture>
        <!--
          <img draggable="false" class="award-logo" src="{{award.logo}}" alt="logo">
        -->
        <div>
          <h5>{{award.franchiseName}}</h5>
          <h5>{{award.name}}</h5>
          <h5>{{award.subline}}</h5>
          <h5>{{award.year}}</h5>
        </div>
      </div>
    </app-carousel-item>
  </app-carousel>
  <app-carousel class="awards-carousel awards-carousel-mobile">
    <app-carousel-item *ngFor="let award of awards">
      <div class="award-container single">
        <responsive-picture
          class="award-logo"
          [alt]="award.name"
          [src]="award.logo"
          ></responsive-picture>
        <!--
          <img draggable="false" class="award-logo" src="{{award.logo}}" alt="logo">
        -->
        <div>
          <h5>{{award.franchiseName}}</h5>
          <h5>{{award.name}}</h5>
          <h5>{{award.subline}}</h5>
          <h5>{{award.year}}</h5>
        </div>
      </div>
    </app-carousel-item>
  </app-carousel>
  
  <div class="footer-nav">
    <article class="tyt-network">
      <h1 class="link">Your TYT</h1>
      <div><a class="link" routerLink="/how-to-watch">How to Watch TYT</a></div>
      <div><a class="link" href="https://help.tyt.com" target="_blank">Get Help</a></div>
      <div><a class="link" routerLink="/redeem">Redeem a Sponsorship</a></div>
      <div><a class="link" routerLink="/archive">Show Archive</a></div>
      <div><a class="link" target="_blank" href="https://secure.actblue.com/donate/tytnetwork">Donate To TYT</a></div>
    </article>

    <article class="social">
      <div class="flex">
        <h1>Follow Us</h1>
        <tyt-social-buttons [follow]=true></tyt-social-buttons>
      </div>
    </article>

    <article class="contact">
      <div class="flex">
        <h1>TYT Network</h1>

        <div><a class="link" routerLink="/about">About Us</a></div>
        <div><a class="link" routerLink="/about/press">Press</a></div>
        <div><a class="link" routerLink="/careers">Jobs</a></div>
        <div><a class="link" routerLink="/about/honor-roll">TYT Honor Roll</a></div>
      </div>
    </article>
  </div>
</footer>

<footer *ngIf="!noLayout" id="drop-footer">
  <div class="flex-area">
    <div class="flex">
      <img src="assets/tyt-light.png" style="height: 1.5em;" />
    </div>
    <div class="flex">
      <p class="copyright" title="Environment: {{environment.name}}">
        © Copyright {{year || 2017}} The Young Turks, Inc. All Rights Reserved.
      </p>
      <div class="links">
        <a href="{{environment.urls.accounts}}/terms">Terms of Use</a>
        | <a href="{{environment.urls.accounts}}/privacy">Privacy Policy</a>
        | <a href="{{environment.urls.accounts}}/core-values">TYT Core Values</a>
      </div>

    </div>

  </div>
</footer>

<div class="devtools" *ngIf="!noLayout && environment.showDevTools">
  <h1>Developer Tools</h1>
  <br/>

  <div>
    <label class="key">Actions:</label>
    <a href="javascript:;" (click)="devLogout()">Logout</a>
    | <a href="javascript:;" (click)="devForcePanic()">Force Panic</a>
  </div>

  <div>
    <label class="key">Comments:</label>
    {{useBanta ? 'Banta' : 'SpotIM'}}
    <a href="javascript:;" (click)="useBanta = !useBanta">Toggle</a>
  </div>
  <div>
    <label class="key">Content Mode:</label>
    {{isDemo ? 'Demo' : 'Production'}}
    <a href="javascript:;" (click)="isDemo = !isDemo">Toggle</a>
  </div>
  <div>
    <label class="key">Onboarding:</label>
    {{isOnboarding ? 'Yes' : 'No'}}
    <a href="javascript:;" (click)="isOnboarding = !isOnboarding">Toggle</a>
  </div>
  <div>
    <label class="key">Icon Reference:</label>
    {{devShowIcons ? 'Shown' : 'Hidden'}}
    <a href="javascript:;" (click)="devShowIcons = !devShowIcons">Toggle</a>
  </div>
  <ng-container *ngIf="devShowIcons">
    <h1>Icons 2019 (<code>/assets/icons-2019/*</code>)</h1>
    <div class="icon-samples">
      <div class="sample-container" *ngFor="let icon of icons2019">
        <div class="holder">
          <img class="icon-sample" src="/assets/icons-2019/{{icon}}" />
        </div>
        <div>
          <strong>{{icon}}</strong><br/>
          <input type="text" (click)="$event.target.select()" value="/assets/icons-2019/{{icon}}" />
        </div>
      </div>
    </div>
  </ng-container>

  <div>
    <label class="key">Open Graph</label>
  </div>

  <pre class="wrapped">{{opengraphMetadata | json}}</pre>

</div>
<ng-container *ngIf="!isServer">
  <media-player #player
    [allowKeyboardControls]="false"></media-player>
  <div id="podcast-player" *ngIf="appPlayingAudio">
    <a href="javascript:;" (click)="closePodcast()" aria-label="Close podcast" class="close-button"><i class="fas fa-times"></i></a>
    <tyt-remote-audio-player></tyt-remote-audio-player>
  </div>
</ng-container>